import { createSlice } from '@reduxjs/toolkit';
import { AbandonedCart, AbandonedCartStatus } from './types/abandoned-cart.ts';
import { RootState } from 'state/store';

export type AbandonedCartState = {
  isLoadingGet: boolean;
  isLoadingPost: boolean;
  isLoadingPatch: boolean;
  errors: unknown[];
  encryptedQuoteId: string;
  data: AbandonedCart;
};

export const initialState: AbandonedCartState = {
  isLoadingGet: true,
  isLoadingPost: false,
  isLoadingPatch: false,
  errors: [],
  encryptedQuoteId: '',
  data: {
    channel: 'Direct Sales',
    status: AbandonedCartStatus.NEW
  }
};

export const slice = createSlice({
  name: 'abandonedCart',
  initialState,
  reducers: {
    setInitialState: (state) => {
      Object.entries(initialState).forEach(
        ([key, value]) => (state[key] = value)
      );
    },
    setIsLoading: (state) => {
      state.isLoadingGet = true;
      state.isLoadingPost = true;
      state.isLoadingPatch = true;
      state.errors = initialState.errors;
    },
    setIsLoadingGet: (state) => {
      state.isLoadingGet = true;
      state.errors = initialState.errors;
    },
    setIsLoadingPost: (state) => {
      state.isLoadingPost = true;
      state.errors = initialState.errors;
    },
    setIsLoadingPatch: (state) => {
      state.isLoadingPatch = true;
      state.errors = initialState.errors;
    },
    setSuccess: (state, { payload }) => {
      state.isLoadingGet = false;
      state.isLoadingPost = false;
      state.isLoadingPatch = false;
      state.data = { ...state.data, ...payload };
      state.errors = initialState.errors;
    },
    setError: (state, { payload }) => {
      state.isLoadingGet = false;
      state.isLoadingPost = false;
      state.isLoadingPatch = false;
      state.errors = payload;
    },
    setEncryptedQuoteId: (state, { payload }) => {
      state.encryptedQuoteId = payload;
    },
    setDataField: (state, { payload: { name, value } }) => {
      state.data[name] = value;
    }
  }
});

export const {
  setInitialState,
  setSuccess,
  setError,
  setIsLoading,
  setIsLoadingPost,
  setIsLoadingGet,
  setIsLoadingPatch,
  setEncryptedQuoteId,
  setDataField
} = slice.actions;

export const selectSlice = (state: RootState) => state[slice.name];
export const selectIsLoadingGet = (state: RootState) =>
  selectSlice(state).isLoadingGet;
export const selectIsLoadingPost = (state: RootState) =>
  selectSlice(state).isLoadingPost;
export const selectIsLoadingPatch = (state: RootState) =>
  selectSlice(state).isLoadingPatch;
export const selectErrors = (state: RootState) => selectSlice(state).errors;
export const selectEncryptedQuoteId = (state: RootState) =>
  selectSlice(state).encryptedQuoteId;
export const selectData = (state: RootState) => selectSlice(state).data;
export const selectProduct = (state: RootState) =>
  selectData(state).products?.[0];

export default slice.reducer;
